import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";

export default class BillOfLading extends Base {
	constructor(props) {
		super(props);
		this.state = {
			orderingId: this.isNull(props.OrderingId) ? null : props.OrderingId,
			caller: props.Caller,
			controllerName: 'billoflading',
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			data: null,
			loading: true,
		};
		this.inputRefs = [];
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	resetRefs() {
		this.inputRefs = [];
	}
	handleKeyDown = (rowIndex, colIndex, e) => {
		const row = this.inputRefs[rowIndex];
		const colCount = row.length;
		const rowCount = this.inputRefs.length;

		if (colCount <= colIndex && rowCount <= rowIndex) return;

		if (e.key === "Enter") {
			e.preventDefault();
			if (colIndex + 1 < colCount) {
				//find first next active input
				if (!row[colIndex + 1]) {
					this.handleKeyDown(rowIndex, colIndex + 1, e);
				}
				else {
					row[colIndex + 1]?.focus();
					if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
				}
			} else if (rowIndex + 1 < rowCount) {
				if (!this.inputRefs[rowIndex + 1][0]) {
					this.handleKeyDown(rowIndex + 1, 1, e);
				}
				else {
					this.inputRefs[rowIndex + 1][0]?.focus();
					if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
				}
			}
		}

		if (e.key === "ArrowDown") {
			e.preventDefault();
			e.preventDefault();
			if (rowIndex + 1 < rowCount) {
				this.inputRefs[rowIndex + 1][colIndex]?.focus();
				if (this.inputRefs[rowIndex + 1][colIndex]?.type === "text") this.inputRefs[rowIndex + 1][colIndex]?.select();
			}
		}

		if (e.key === "ArrowUp") {
			e.preventDefault();
			if (rowIndex - 1 >= 0) {
				this.inputRefs[rowIndex - 1][colIndex]?.focus();
				if (this.inputRefs[rowIndex - 1][colIndex]?.type === "text") this.inputRefs[rowIndex - 1][colIndex]?.select();
			}
		}
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();

		this.httpPost("api/v1/billoflading/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					if (!this.isNull(this.state.orderingId) && this.state.data.record.id === this.getDefaultGuid()) {
						this.setOrdering({ value: this.state.orderingId, label: '' });
					}
					this.state.loading = false;
				}
				else {
					//this.showErorrMessage(data.message);
					this.setState({
						data: data,
						loading: false
					});
				}
			});
	}
	save(e) {
		e.preventDefault();
		if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;
		if (this.isBlank(this.state.data.record.price)) this.state.data.record.price = 0;

		this.httpPost("api/v1/billoflading/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			number: this.state.data.record.number,
			orderingId: this.state.data.record.orderingId,
			date: this.convertMomentToDb(this.state.data.record.date),
			sharedMethod: this.state.data.record.sharedMethod,
			carrierId: this.state.data.record.carrierId,
			destinationPort: this.state.data.record.destinationPort,
			originPort: this.state.data.record.originPort,
			price: this.state.data.record.price,
			description: this.state.data.record.description,
			transportationType: this.state.data.record.transportationType,
			items: this.state.data.record.items,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("بارنامه با موفقیت ذخیره شد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData(null, "list", "json", (this.state.id === this.getDefaultGuid() ? true : false));

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	removeRow(id) {
		this.resetRefs();
		var temp = [];
		var index = 1;
		this.state.data.record.items.sort((a, b) => a.index - b.index).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].index = index;
				index++;
			}
		});
		this.state.data.record.items = temp;
		this.allocateAmount();
	}
	upIndex(id) {
		this.resetRefs();
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.record.items[idIndex].index;
			this.state.data.record.items[idIndex].index = ii - 1;
			this.state.data.record.items[idIndex - 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndex(id) {
		this.resetRefs();
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.record.items.length - 1) {
			var ii = this.state.data.record.items[idIndex].index;
			this.state.data.record.items[idIndex].index = ii + 1;
			this.state.data.record.items[idIndex + 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	doEnterAfterSelect(rowIndex, colIndex) {
		const row = this.inputRefs[rowIndex];
		const colCount = row.length;
		const rowCount = this.inputRefs.length;

		if (colCount <= colIndex && rowCount <= rowIndex) return;

		if (colIndex + 1 < colCount) {
			//find first next active input
			if (!row[colIndex + 1]) {
				this.doEnterAfterSelect(rowIndex, colIndex + 1);
			}
			else {
				row[colIndex + 1]?.focus();
				if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
			}
		} else if (rowIndex + 1 < rowCount) {
			if (!this.inputRefs[rowIndex + 1][0]) {
				this.doEnterAfterSelect(rowIndex + 1, 1);
			}
			else {
				this.inputRefs[rowIndex + 1][0]?.focus();
				if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
			}
		}
	}
	setCarrier(e) {
		if (e.value == -1) {
			this.state.data.record.carrierId = null;
			this.state.data.record.carrierName = '';
			this.showComponents({
				component: <Person Caller={this} FromAutoComplete={true} />,
			});
			return;
		}
		this.state.data.record.carrierId = e.value;
		this.state.data.record.carrierName = e.label;
		this.setState({ data: this.state.data });
	}
	onEditCarrier(id) {
		this.showComponents({ component: <Person Caller={this} Id={id} FromAutoComplete={true} /> });
	}
    setOrdering(e) {
        if (e === null) {
            this.state.data.record.orderingId = null;
            this.state.data.record.orderingFullNumber = '';
			this.state.data.record.items = [];
			this.allocateAmount();
        }
        else {
            this.state.data.record.orderingId = e.value;
            this.state.data.record.orderingFullNumber = e.label;
            this.state.data.record.items = [];

            this.httpPost('api/v1/billoflading/search/factor', {
                orderingId: this.state.data.record.orderingId,
            }).then((data) => {
                if (data.status === -1) window.location.href = '/login';
                if (data.status === 1) {
                    this.state.loading = false;
					this.state.data.record.items = data.records;
					this.allocateAmount();
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false,
                    });
                }
            });

        }
        this.setState({ data: this.state.data });
	}
	allocateAmount() {
		var weightField = 'total';
		if (this.state.data.record.sharedMethod === 0) weightField = 'total';
		if (this.state.data.record.sharedMethod === 1) weightField = 'count';
		if (this.state.data.record.sharedMethod === 2) weightField = 'count';

		if (this.state.data.record.sharedMethod === 3) return;

		var totalAmount = this.state.data.record.price;

		if (this.state.data.record.sharedMethod === 4) {

			const equalShare = Math.floor(totalAmount / this.state.data.record.items.length);
			let allocatedSum = 0;

			this.state.data.record.items.forEach((row, index) => {
				let share;

				// آخرین آیتم باقیمانده را می‌گیرد
				if (index === this.state.data.record.items.length - 1) {
					share = totalAmount - allocatedSum;
				} else {
					share = equalShare;
					allocatedSum += share;
				}

				row.billOfLadingCost = share;
			});

			this.setState({ data: this.state.data });
			return;
		}

		const totalWeight = this.state.data.record.items.reduce(
			(sum, row) => sum + row[weightField],
			0
		);

		let allocatedSum = 0;

		this.state.data.record.items.forEach((row, index) => {
			let share;

			// آخرین ردیف مانده را می‌گیرد تا جمع دقیقاً برابر شود
			if (index === this.state.data.record.items.length - 1) {
				share = totalAmount - allocatedSum;
			} else {
				share = Math.floor(totalAmount * row[weightField] / totalWeight);
				allocatedSum += share;
			}

			row.billOfLadingCost = share;
		});
		this.setState({ data: this.state.data });
	}
	getBodySum(f) {
		var sum = 0;
		this.state.data.record.items.forEach(body => {
			sum += body[f];
		});
		return sum
	}
	//override
	remove() {
		var id = this.state.id_to_remove;
		if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

		this.httpPost("api/v1/" + this.state.controllerName + "/remove", {
			id,
			companyId: this.state.data.global.company.id,
			organizationId: this.state.data.global.company.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({ showConfirmRemove: false });
				}
			})
			.catch(err => {
				this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
			});
	}
	renderBody() {
		var trs = [];
		this.state.data.record.items.sort((a, b) => a.index - b.index).forEach((item, index) => {
			var tds = [];
			let refColumnIndex = 0;

			tds.push(<td>
				<span className="inGridRowNumber">{(index + 1)}</span>
				{<div style={{ "font-size": "9pt", "color": "silver" }}>
					{index > 0 && index != this.state.data.record.items.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
					{index < this.state.data.record.items.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
				</div>}
			</td>);

			tds.push(<td>{item.factorNumber}</td>);
			tds.push(<td>{item.stuffName}</td>);
			tds.push(<td>{item.count}</td>);
			tds.push(<td>{item.unitName}</td>);

			if (this.state.data.global.company.stuffSubUnitEnable === 2) {
				tds.push(<td>{item.modulusCount}</td>);
				tds.push(<td>{item.modulusUnitName}</td>)
			}

			tds.push(<td>{this.money(item.total)}</td>);
			tds.push(<td>{this.money(item.billOfLadingCost)}</td>);

			tds.push(<td>
				<span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
			</td>);

			trs.push(<tr key={item.id}>
				{tds}
			</tr>);
		});

		return <tbody>{trs}</tbody>
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">بارنامه</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">

								{this.isNull(this.state.orderingId) && <div className="col-sm-3">
									<div className="form-group">
										<label for="invoiceContact" className="title1">سفارش<span className="red">*</span></label>
										<SelectAsync
											value={
												!this.isNull(this.state.data.record.orderingId)
													? [
														{
															value: this.state.data.record.orderingId,
															label: this.state.data.record.orderingFullNumber,
														},
													]
													: null
											}
											isMulti={false}
											placeholder="انتخاب سفارش"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadOrderingsOptions(inputValue, callback, 4)}
											onChange={e => this.setOrdering(e)}
										/>
									</div>
								</div>}
								<div className="col-sm-3">
									<div className="form-group">
										<label for="invoiceContact" className="title1">شرکت حمل<span className="red">*</span></label>
										<div id="displayPersonBalance" style={{ "display": "inline-block" }} ></div>
										<em className="icon ni ni-plus hand ms-1" onClick={e => this.setCarrier({ value: -1 })}></em>,
										{!this.isNull(this.state.data.record.carrierId) && <em onClick={e => this.onEditCarrier(this.state.data.record.carrierId)} className="icon ni ni-pen hand ms-1"></em>}
										<SelectAsync
											value={!this.isNull(this.state.data.record.carrierId) ? [{ value: this.state.data.record.carrierId, label: this.state.data.record.carrierName }] : null}
											isMulti={false}
											placeholder="انتخاب شرکت"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1)}
											onChange={e => this.setCarrier(e)}
										/>
									</div>
								</div>

								<div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceDate" className="title1">تاریخ<span className="red">*</span></label>
										<DatePicker
											inputReadOnly={false}
											className="form-control input-sm persian-date"
											placeholder={"تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.date = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
										/>
									</div>
								</div>
								<div className="col-sm-1">
									<div className="form-group">
										<label className="title1">شماره</label>
										<input onChange={e => this.state.data.record.number = parseInt(e.target.value)} defaultValue={this.state.data.record.number} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="20" />
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label className="title1">مبلغ بارنامه</label>
										<NumberFormat value={this.state.data.record.price} onChange={e => {
											this.state.data.record.price = parseInt(e.target.value.replace(/,/g, ''));
											this.allocateAmount();
										}} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
									</div>
								</div>
								<div className="col-sm-1">
									<div className="form-group">
										<label className="title1">روش تسهیم</label>
										<select onChange={(e) => {
											this.state.data.record.sharedMethod = parseInt(e.target.value);
											this.allocateAmount();
										}} defaultValue={this.state.data.record.sharedMethod} className="form-control">
											<option value="0">قیمتی</option>
											<option value="1">وزنی</option>
											<option value="2">تعدادی</option>
											{/*<option value="3">دستی</option>*/}
											<option value="4">نسبت مساوی</option>
										</select>
									</div>
								</div>
								<div className="col-sm-1">
									<div className="form-group">
										<label className="title1">نوع حمل</label>
										<select onChange={(e) => this.state.data.record.transportationType = parseInt(e.target.value)} defaultValue={this.state.data.record.transportationType} className="form-control">
											<option value="0">انتخاب</option>
											<option value="1">دریایی</option>
											<option value="2">زمینی</option>
											<option value="3">هوایی</option>
											<option value="4">ریلی</option>
										</select>
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label className="title1">مبدا</label>
										<input onChange={e => this.state.data.record.originPort = e.target.value} defaultValue={this.state.data.record.originPort} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="150" />
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label className="title1">مقصد</label>
										<input onChange={e => this.state.data.record.destinationPort = e.target.value} defaultValue={this.state.data.record.destinationPort} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="150" />
									</div>
								</div>
								<div className="col-sm-8">
									<div className="form-group">
										<label className="title1">توضیحات</label>
										<input onChange={e => this.state.data.record.description = e.target.value} defaultValue={this.state.data.record.description} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="400" />
									</div>
								</div>
							</div>

							<div className="row">
								<div className={"col-lg-12"}>
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td style={{ "width": "30px" }}>#</td>
												<td style={{ minWidth: "60px" }}>فاکتور</td>
												<td style={{ minWidth: "200px" }}>آیتم</td>
												<td style={{ "width": "70px" }}>
													<span>تعداد/مقدار</span>
												</td>
												<td>واحد اصلی</td>
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td style={{ "width": "70px" }}>
													<span>تعداد/مقدار<br />فرعی</span>
												</td>}
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>واحد فرعی</td>}
												<th style={{ width: '100px' }}><span>مبلغ کل</span></th>
												<th style={{ width: '100px' }}><span>مبلغ بارنامه</span></th>
												<td style={{ "width": "35px" }}></td>
											</tr>
										</thead>
										{this.renderBody()}
									</table>
								</div>
							</div>

						</div>
						<div className="modal-footer">
							<button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره</button>
							&nbsp;
							{this.state.data.record.id !== this.defaultGuid() && <a className="btn btn-danger me-2" onClick={e => this.confirmRemove(this.state.data.record.id, !this.fromOrdering())} >حذف فاکتور</a>}
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.state.data.status === 0 ? this.apiFailInModal() : this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}